var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAPosters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.6666C3.5 7.26709 3.5 5.06675 4.86733 3.70059C6.23467 2.33442 8.43383 2.33325 12.8333 2.33325H15.1667C19.5662 2.33325 21.7665 2.33325 23.1327 3.70059C24.4988 5.06792 24.5 7.26709 24.5 11.6666V16.3333C24.5 20.7328 24.5 22.9331 23.1327 24.2993C21.7653 25.6654 19.5662 25.6666 15.1667 25.6666H12.8333C8.43383 25.6666 6.2335 25.6666 4.86733 24.2993C3.50117 22.9319 3.5 20.7328 3.5 16.3333V11.6666Z",
    stroke: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 13.9999H18.6673M9.33398 9.33325H18.6673M9.33398 18.6666H15.1673",
    stroke: "#00ADEF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAPosters);
export default __webpack_public_path__ + "static/media/A-Posters.889bbaa858d3bc5f905fde321c69ef68.svg";
export { ForwardRef as ReactComponent };